import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListSegmentsComponent } from './components/list-segments/list-segments.component';
import { AddSegmentsComponent } from './components/add-segments/add-segments.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterSegmentComponent } from './components/filter-segment/filter-segment.component';



@NgModule({
  declarations: [
    ListSegmentsComponent,
    AddSegmentsComponent,
    FilterSegmentComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SegmentsModule { }
